const Post = async ( body, path ) => {

    var body_req = JSON.stringify(body)
    
        let response = await fetch(path, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          mode: 'cors',
          body: body_req,
        })

        if(response.status !== 200){
          return {status:false}
        }
    
        let res = await response.json()
        console.log("Network response")
        console.log(res)
    
        return res;
    
    }


    const createQuery = (params) =>{
        var search = "?"

        Object.keys(params).map(function(field){// eslint-disable-line
           
          if(params[field] !== "" && params[field] !== undefined ){
           
    
            var field_value = params[field]
            if(field_value instanceof Array){
              field_value = field_value.join(';')
            }
            search = search.concat(field).concat('=').concat(field_value).concat('&')


          }
         
          
        })

      

        return search
    }
    
    const Get = async ( path, query, raw_response ) => {
    
        // var body_req = JSON.stringify(body)
            let fullPath = query ? path.concat(createQuery(query)):path

            let response = await fetch(fullPath, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
              },
              mode: 'cors',
              
            })

            let res;
            
            if(raw_response){
             
             res = await response
            }
            else{
              res = await response.json()
            }
        
         
           
        
            return res;
        
        }
    
    const ws = {
      Post:Post,
      Get:Get
    }
    export default ws